import StickySquare from './StickySquare'

export default StickySquare
